import {api} from 'utils/api';

/**
 * React hook wrapper for api (for backwards compatibility)
 * For non-React code, import { api } from 'utils/api' directly
 */
export const useApi = () => api;
